import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { EventName } from '../services/analytics/event-names';
import { PAGE } from 'src/app/routes';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoadingAuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);

  public async canActivate(): Promise<boolean> {
    this.analyticsService.log(EventName.LoadingGuard);
    if (environment.telegram || (await this.authService.userExists())) {
      return true;
    }

    this.router.navigate([`/${PAGE.SIGNIN}`]);
    return false;
  }
}
